import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { SharedModule } from "../../shared.module";
import { ConfirmDialogModule } from "../confirm-dialog/confirm-dialog.module";
import { ShareSocialMediasDialogModule } from "../share-social-medias-dialog/share-social-medias-dialog.module";
import { CertificateViewerComponent } from "./certificate-viewer.component";

@NgModule({
    declarations: [CertificateViewerComponent],
    exports: [CertificateViewerComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        NgxSpinnerModule,
        MatIconModule,
        SharedModule,
        TranslateModule,
        MatMenuModule,
        ConfirmDialogModule,
        MatTooltipModule,
        FlexLayoutModule,
        FlexModule,
        ShareSocialMediasDialogModule
    ]
})
export class CertificateViewerModule {}
